import { ContentElementPodigee as CePodigeeDefault } from '@vgn-medien-holding/vgn-fe-components';
import elementStyle from './styles/default';

export default function ContentElementPodigee(element) {
  return <CePodigeeDefault element={element} classProps={elementStyle} />;
}
